import axios from "axios";
import { Button, DataGrid } from "devextreme-react";
import {
  Column,
  FilterRow,
  GroupPanel,
  Grouping,
  HeaderFilter,
  LoadPanel,
  Lookup,
  Scrolling,
  SearchPanel,
  Selection,
  StateStoring,
  Toolbar,
} from "devextreme-react/data-grid";
import { Item } from "devextreme-react/toolbar";
import CustomStore from "devextreme/data/custom_store";
import React, { useEffect, useRef, useState } from "react";
import { CAT, CAT_FILTER } from "./data";
import FileItem from "./FileItem";

export default function AuditDocumentGrid() {
  const gridRef = useRef(null);

  const [dataSource, setDataSource] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "docNo",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/adtDocV`
          );

          return result.data;
        },
      })
    );
  }, []);

  const onRowPrepared = (e) => {
    if (e.rowType == "data") {
      e.rowElement.style.height = "50px";
    }
  };

  const onClickCollapseAll = () => {
    setExpanded(!expanded);
  };

  const onClickTop = () => {
    gridRef.current.instance.getScrollable().scrollTo(0);
  };

  const renderGridCell = (data) => {
    const { docNo, docTitle } = data.data;

    return <FileItem docNo={docNo} docTitle={docTitle} />;
  };

  const onClickRefresh = () => {
    gridRef.current.instance.getDataSource().reload();
  };

  return (
    <div
      className="list"
      style={{
        // width: "1000px",
        width: "700px",
        paddingLeft: "10px",
      }}
    >
      <DataGrid
        id="auditDocumentGrid"
        ref={gridRef}
        dataSource={dataSource}
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        allowColumnResizing={true}
        height={"100%"}
        style={{
          maxHeight: "calc(100vh - 145px)",
        }}
        onRowPrepared={onRowPrepared}
      >
        <LoadPanel enabled={true} />

        <Grouping autoExpandAll={expanded} expandMode={"rowClick"} />
        <GroupPanel visible={true} />

        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <SearchPanel visible={true} width={240} placeholder={"Search..."} />

        <Selection mode={"single"} />

        <Scrolling
          mode={"virtual"}
          preloadEnabled={true}
          showScrollbar={"always"}
        />

        <Toolbar>
          <Item location={"before"}>
            <Button
              style={{ backgroundColor: "#f5f5f5" }}
              icon={expanded ? "chevronright" : "chevrondown"}
              onClick={onClickCollapseAll}
            />
          </Item>
          <Item name="groupPanel" />
          <Item location="after">
            <Button
              style={{ backgroundColor: "#f5f5f5" }}
              icon="chevronup"
              onClick={onClickTop}
            />
          </Item>
          <Item>
            <Button icon="refresh" onClick={onClickRefresh} />
          </Item>

          <Item location={"after"} name="searchPanel" />
        </Toolbar>

        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey={"AuditDocumentViewer.AuditDocumentGrid"}
        />

        <Column
          dataField={"cat"}
          caption="Category"
          dataType={"string"}
          groupIndex={0}
        >
          {/* <Lookup dataSource={CAT} valueExpr={"id"} displayExpr={"name"} />
          <HeaderFilter dataSource={CAT_FILTER} /> */}
        </Column>
        <Column
          dataField={"docTitle"}
          caption={"Document Title"}
          dataType={"string"}
        />
        <Column
          caption={"File"}
          // width={120}
          width={50}
          alignment={"center"}
          cellRender={renderGridCell}
        />
      </DataGrid>
    </div>
  );
}
